var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_515_661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9542 2.73999L34.6592 5.03499",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6592 2.73999L19.7842 4.86499",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3066 1.125V4.12125",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4117 15.8661C13.1664 14.6209 13.1664 12.6021 14.4117 11.359C15.6569 10.1137 17.6757 10.1137 18.9188 11.359L27.1829 19.6231L31.69 24.1302V18.4161C31.69 16.5929 33.169 15.1139 34.9923 15.1139C36.5669 15.1139 37.9227 16.2252 38.2308 17.768L40.6087 29.6616C41.6074 34.6532 40.0455 39.8149 36.4437 43.4146C30.4979 49.3604 20.8568 49.3604 14.911 43.4146L9.1523 37.6537L3.89292 32.3944C2.64767 31.1491 2.64767 29.1304 3.89292 27.8872C5.13817 26.642 7.15692 26.642 8.40005 27.8872",
    stroke: "#0D0D0D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1643 34.649L5.3978 24.8825C4.15255 23.6372 4.15255 21.6185 5.3978 20.3753C6.64305 19.1301 8.6618 19.1301 9.90493 20.3753",
    stroke: "#0D0D0D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.671 30.1398L6.89976 17.3686C5.65451 16.1233 5.65451 14.1046 6.89976 12.8614C8.14501 11.6162 10.1638 11.6162 11.4069 12.8614L24.1781 25.6327",
    stroke: "#0D0D0D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_515_661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/handIcon.4b8b2ec21eba5e265b63fb4378245d6c.svg";
export { ForwardRef as ReactComponent };